import { DateOnly } from '@microsoft/kiota-abstractions';

type DateInput = Date | DateOnly | string | null | undefined;

export function toDateOnly(value: DateInput): DateOnly | null | undefined {
  if (value === undefined) {
    return undefined;
  }

  if (value === null || value === '') {
    return null;
  }

  if (value instanceof DateOnly) {
    return value;
  }

  if (value instanceof Date) {
    return DateOnly.fromDate(value);
  }

  if (typeof value === 'string') {
    return DateOnly.parse(value) ?? null;
  }

  return undefined;
}

export function toDateOnlyString(value: { toString(): string } | null | undefined): string | null {
  return value?.toString() ?? null;
}

export function toOptionalNumber(value: unknown): number | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function toNullableNumber(value: unknown): number | null | undefined {
  if (value === undefined) {
    return undefined;
  }

  if (value === null || value === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function toBoolean(value: unknown, fallback?: boolean): boolean | null | undefined {
  if (value === undefined) {
    return fallback;
  }

  if (value === null || value === '') {
    return null;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (normalized === 'true') {
      return true;
    }

    if (normalized === 'false') {
      return false;
    }
  }

  return Boolean(value);
}

export function buildAbstractMap<T extends { id?: number | null }>(
  rows: T[] | null | undefined,
  getLabel: (row: T) => string | null | undefined
): Record<string, string> {
  return Object.fromEntries(
    (rows ?? [])
      .filter((row): row is T & { id: number } => row.id !== null && row.id !== undefined)
      .map(row => [String(row.id), String(getLabel(row) ?? '')])
  );
}
